import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import AppContainer from '../../components/_common/_containers/AppContainer'
import NRTFormUserSignIn from '../../components/FormUserSignIn'
import Logo from '../../components/_minha-central/Logo'
import NRTHorizontalStack from '../../components/_common/_containers/HorizontalStack'
import NRTButton from '../../components/_common/_buttons/Button'
import NRTCardStack from '../../components/_common/CardStack'
import NRTVerticalStack from '../../components/_common/_containers/VerticalStack'
import NRTFormInput from '../../components/_common/_form/FormInput'
import NRTFormStateManager from '../../components/_common/_form/FormStateManager'
import NRTFormUserSignUp from '../../components/FormUserSignUp'
import NRTFormContainer from '../../components/_common/_form/_containers/FormContainer'
import BackButton from '../../components/_common/_buttons/BackButton'
import {Helmet} from 'react-helmet'
import {Validators} from '../../components/_common/_form/Validators'
import {formatLogin} from '../../helpers/login'
import _ from 'lodash'
import PersonRequests from "../../requests/person-requests"
import Spinner from '../../components/_common/Spinner'
import NRTTooltip from "../../components/_common/Tooltip"
import {PersonTypeEnum} from "../../enums/PersonTypeEnum"


const icon = require('../../components/FormUserSignIn/information.png')

const SIMULATE_PASSWORD_RECOVER_ERROR = false


class LoginPage extends Component {

    static ACCOUNT_ROUTE = '/conta'

    state = {
        activeCard: 0,
        loginFail: false,
        loading: false,
        awaiting: false,
    }


    componentDidMount() {
        if (this.props.context.person)
            this.props.history.push('/conta')
    }


    static getDerivedStateFromProps(nextProps) {
        const {match} = nextProps
        const {params} = match

        switch (params.step) {
            default:
                return {activeCard: 0}
                break
            case 'esqueceu-senha':
            case 'cadastro':
                return {activeCard: 1}
                break

        }
    }


    tryLogin = (login, password) => {


        const {credentials} = this.props.context

        this.setState({
            awaiting: true,
            loginFail: false,
        }, () => {

            this.props.tryLogin(credentials.schema, login, password)
                .then(({success, person}) => {

                    if (success) {

                        const types = _.get(person, 'types' , '')
                        const isTeacher =  types.split('|').some(type=>type === PersonTypeEnum.TEACHER + '')
                        this.props.context.set({
                            person,
                            isTeacher,
                        }, () => this.props.history.push(LoginPage.ACCOUNT_ROUTE))
                    } else {
                        this.setState({
                            loginFail: true,
                            awaiting: false,
                        })
                    }
                })
                .catch(this.onError)

        })
    }


    recoverPassword = () => {
        this.setState({loading: true})

        const schema = this.props.context.credentials.schema
        const inputLoginValue = this.refs.inputLogin.state.value + ''

        if (inputLoginValue === '')
            return

        const formattedLogin = formatLogin(inputLoginValue)
        const login = `${schema}.${formattedLogin}`

        const req = SIMULATE_PASSWORD_RECOVER_ERROR ?
            Promise.reject('Erro simulado') : PersonRequests.recoverPassword(login)

        req
            .then(result => {
                if (result.success) {
                    this.setState({loading: false})

                    this.props.context.set({
                        toastMessage: {
                            type: 'success',
                            content: 'Abra o e-mail que foi encaminhado, ou acesse o portal com o número do seu cpf.'
                        }

                    }, () => {
                        setTimeout(() => {
                            this.props.history.push('/login/inicio')
                        }, 3000)

                    })

                } else {

                    this.props.context.set({
                        toastMessage: {
                            type: 'error',
                            content: 'Desculpe, não encontramos nenhum usuário com este login.'
                        }

                    })

                }


            })
            .catch(error => {

                this.props.context.logError(error)
                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Desculpe, mas o serviço está indisponível no momento.'
                    }

                })


            })
    }


    onError = (error) => {
        this.setState({
            error,
            awaiting: false
        })

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: 'Desculpe, mas o serviço está indisponível no momento.'
            }

        })

        this.props.context.logError(error)
    }


    gotToSignUpForm = () => this.props.history.push('/login/cadastro')


    goToForgotPassword = () => this.props.history.push('/login/esqueceu-senha')


    newUserSuccess = (person) => {

        this.props.context.set({
            toastMessage: {
                type: 'success',
                content: 'Cadastro feito com sucesso!'
            }
        }, () => {
            this.props.context.set(
                {person},
                () => {
                    setTimeout(() => {
                        this.props.history.push('/')
                    }, 500)

                }
            )
        })
    }

    newUserFail = (errorMsg) => {
        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: errorMsg + 'Caso já possua cadastro, clique em esqueceu sua senha!'
            }
        })
    }


    formChanged = form => {
        this.setState({
            loginFail: false,
            formValid: form.valid,
            ...form.values
        })
    }


    render() {
        const {

            title,
            match,
            context,
        } = this.props

        const loginBackground = _.get(context, 'systemConfigParameterValue.loginBackground', null)
        const logo = _.get(context, 'systemConfigParameterValue.logo', null)
        const {
            loginFail,
            awaiting
        } = this.state
        const {params} = match


        const cardSignUp = (

            <div className={''}>
                <div className={'card'}>

                    <BackButton onClick={() => this.props.history.push('/login/inicio')}/>


                    <NRTFormContainer title={'Faça seu cadastro'}
                                      formStyle={{
                                          background: 'rgba(255,255,255,.6)',
                                      }}>

                        <NRTFormUserSignUp onFail={this.newUserFail}
                                           onSuccess={this.newUserSuccess}
                                           schema={context.credentials.schema}
                        />

                    </NRTFormContainer>
                </div>
            </div>

        )


        const cardForgotPassword = (
            <div className={''}>
                <div className={'card'}>


                    <BackButton onClick={() => this.props.history.push('/login/inicio')}/>

                    <NRTFormContainer title={'Digite seu login'}>

                        <NRTVerticalStack>

                            <div style={{position: 'relative'}}>
                                <NRTFormInput name={'login'}
                                              label={'Login'}
                                              validators={[Validators.required()]}
                                              ref="inputLogin"/>

                            <NRTTooltip
                                 position={'right'}
                                 text={`Se você for cliente, seu login é seu CPF ou CNPJ. Caso seja colaborador ou instrutor,
                                      seu login é o mesmo do sistema`}>
                                 <img src={icon}/>
                             </NRTTooltip>

                            </div>

                            <NRTButton
                                onClick={this.recoverPassword}
                                content={this.state.loading ? <Spinner width={32}/> : 'Recuperar senha'}/>
                        </NRTVerticalStack>
                    </NRTFormContainer>
                </div>
            </div>

        )

        const nextStep = (params.step === 'cadastro') ? cardSignUp : cardForgotPassword


        return (
            <AppContainer
                showFooter={false}
                showHeader={false}
                style={{

                    background: `url(${loginBackground})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}

            >
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{title || ''} | Login </title>
                </Helmet>
                <div className="nrt-login-page" style={{zIndex: 333}}>

                    <NRTCardStack activeCard={this.state.activeCard}>

                        <div className={''}>
                            <div className={'card'}>
                                <div style={{textAlign: 'center'}}>
                                    <Logo
                                        imgSrc={logo}
                                        style={{
                                            marginBottom: '2rem',
                                        }}
                                    />
                                </div>
                                <div>
                                    <NRTFormStateManager onStateChange={this.formChanged}>


                                        <NRTFormUserSignIn onSubmit={this.tryLogin}
                                                           loginFail={loginFail}
                                                           awaiting={awaiting}
                                        />

                                        <NRTHorizontalStack>

                                            <NRTButton onClick={this.goToForgotPassword} secondary
                                                       style={{
                                                           fontSize: '.65rem'
                                                       }}
                                                       content={'esqueceu sua senha?'}/>

                                            <NRTButton onClick={this.gotToSignUpForm}
                                                       content={'Novo Cadastro'}/>
                                        </NRTHorizontalStack>


                                    </NRTFormStateManager>

                                </div>
                            </div>
                        </div>

                        {nextStep}

                    </NRTCardStack>
                </div>


            </AppContainer>
        )
    }
}

LoginPage.propTypes = {
    tryLogin: PropTypes.func.isRequired,
}

LoginPage.defaultProps = {}


export default LoginPage



// WEBPACK FOOTER //
// ./src/_pages/Login/index.js